Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.userStatusTitle = "User Status List";
exports.userStatusApiMethod = "GET";
exports.userStatusApiContentType = "application/json";
exports.userStatusApiEndpont = "user_status/user_status";
// Customizable Area End